module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"back":"返回"},"en":{"back":"返回"},"fr":{"back":"返回"},"de":{"back":"返回 "},"jp":{"back":"返回"},"es":{"back":"返回"},"pt":{"back":"返回"},"it":{"back":"返回"},"tw":{"back":"返回"},"kr":{"back":"返回"},"id":{"back":"返回"}}')
  delete Component.options._Ctor
}
